import { Box, Typography } from '@mui/material'
import { themeColors } from '../../app/layout/theme'

const STATUS_CONFIG: Record<string, { color: string; bg: string }> = {
  'New':          { color: themeColors.info,    bg: themeColors.infoLight },
  'Working':      { color: themeColors.info,    bg: themeColors.infoLight },
  'Escalated':    { color: themeColors.error,   bg: themeColors.errorLight },
  'Resolved':     { color: themeColors.success, bg: themeColors.successLight },
  'Closed':       { color: '#706e6b',           bg: '#f3f2f2' },
  'Converted':    { color: themeColors.success, bg: themeColors.successLight },
  'Junk':         { color: themeColors.error,   bg: themeColors.errorLight },
  'JUNK':         { color: themeColors.error,   bg: themeColors.errorLight },
  'Nuevo':        { color: themeColors.info,    bg: themeColors.infoLight },
  'Contactado':   { color: themeColors.primary, bg: `${themeColors.primary}12` },
  'Nurturing':    { color: themeColors.warning, bg: themeColors.warningLight },
  'No cualificado': { color: '#706e6b',         bg: '#f3f2f2' },
  'Not Started':  { color: '#706e6b',           bg: '#f3f2f2' },
  'In Progress':  { color: themeColors.warning, bg: themeColors.warningLight },
  'Completed':    { color: themeColors.success, bg: themeColors.successLight },
  'Low':          { color: themeColors.success, bg: themeColors.successLight },
  'Medium':       { color: themeColors.warning, bg: themeColors.warningLight },
  'High':         { color: themeColors.error,   bg: themeColors.errorLight },
  'Media':        { color: themeColors.warning, bg: themeColors.warningLight },
}

interface StatusBadgeProps {
  status: string
  size?: 'small' | 'medium'
}

export const StatusBadge = ({ status, size = 'small' }: StatusBadgeProps) => {
  const config = STATUS_CONFIG[status] || { color: themeColors.text.secondary, bg: '#f3f2f2' }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        px: size === 'small' ? '8px' : '10px',
        py: size === 'small' ? '2px' : '4px',
        borderRadius: '12px',
        backgroundColor: config.bg,
        border: `1px solid ${config.color}30`,
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: config.color,
          flexShrink: 0,
        }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: size === 'small' ? '11px' : '13px',
          fontWeight: 600,
          color: config.color,
          whiteSpace: 'nowrap',
          lineHeight: 1,
        }}
      >
        {status}
      </Typography>
    </Box>
  )
}
